module.exports = __webpack_public_path__ + "static/media/navidad10.1118bb87.webp";